import type { Rarity } from './models/types';

/**
 * The bubbly EthrHunt palette for the web app. The accent colours (coral/lime/sky/lemon) were
 * bolded in response to issue #68 ("the colors look like garbage" / too peachy and pastel) — this
 * is the "Tropic Pop" option the maintainer picked from `openspec/changes/issue-68-bold-accent-colors/`.
 * `cream` and `ink` are unchanged. The Flutter client's theme (`client/lib/theme/`) is a separate,
 * untouched palette.
 */
export const colors = {
  coral: '#FF5A1F',
  lime: '#00D9A3',
  sky: '#3772FF',
  lemon: '#FFB400',
  cream: '#FFF8F0',
  ink: '#2B2D42',
} as const;

export const rarityColors: Record<Rarity, string> = {
  common: '#7C8DB5',
  uncommon: '#3DCC7E',
  rare: '#3B8BFF',
  epic: '#A259FF',
  legendary: '#FFB800',
};

/** `#rrggbb` + alpha 0..1 -> `rgba(...)`. */
export function withAlpha(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const n = Number.parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
